import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession, fetchUserTxById, resetFetchUserTxById } from '../actions'
import { updateIdentity } from '../actions/identity_info_modal_dialog'
import { resetModalConfirmation } from '../actions/modal_confirmation'
import { fetchGenericTypeDocuments } from '../actions/supported_documents'
import { updateDocumentData } from '../actions/update_document_data'
import { DivTitleBox } from '../components/common/styled'
import CorporateForm from '../components/manual-aml/corporate_form'
import IndividualForm from '../components/manual-aml/individual_form'
import { APP_USER, STORAGE_TYPE_LOCAL } from '../config'
import StorageProviderFactory from '../managers/storage_provider_factory'
import { isStaff, isClientAdmin } from '../utils/helpers'

const selectedStyles = {
  color: 'inherit',
  border: '1px solid #d2d2d2',
  backgroundColor: '#e6e6e6',
}

export class ManualAml extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isCorporate: false,
      disabled: false,
    }
  }

  styles = (isCorporate) => {
    if (isCorporate) {
      return selectedStyles
    } else {
      return {}
    }
  }

  componentDidMount() {
    const user = JSON.parse(StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(APP_USER))
    let disabled = true
    if (isClientAdmin(user) || isStaff(user)) {
      disabled = false
    }
    this.setState({ disabled })
  }

  render() {
    const { state } = this
    const { isCorporate, disabled } = state
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-8 col-sm-8'>
              {' '}
              <h2>AML Only Form</h2>
            </div>
            <div className='col-xs-4 col-sm-4 text-end'>
              <Button
                bsPrefix='btn btn-w-m btn-default'
                onClick={() => this.setState({ isCorporate: true })}
                style={{ marginRight: 5, ...this.styles(isCorporate) }}
              >
                <>
                  <i className='fa fa-users' />
                  {' Corporate'}
                </>
              </Button>

              <Button
                bsPrefix='btn btn-w-m btn-default'
                onClick={() => this.setState({ isCorporate: false })}
                style={{ ...this.styles(!isCorporate) }}
              >
                <>
                  <i className='fa fa-male' />
                  {' Individual'}
                </>
              </Button>
            </div>
          </div>
        </DivTitleBox>
        {!isCorporate && <IndividualForm disabled={disabled} />}

        {isCorporate && <CorporateForm disabled={disabled} className='ibox-content' />}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkSession,
      fetchUserTxById,
      updateDocumentData,
      resetModalConfirmation,
      resetFetchUserTxById,
      fetchGenericTypeDocuments,
      updateIdentity,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManualAml))
